<template>
	<!-- <div class="page-wrapper">
    <b-container class="container-fluid">
      <b-row>   
          <b-row>
             <b-col cols="3">
               <SideBar/>
              </b-col>
             <b-col >                   
              <transition name="fade-transform" mode="out-in">
                <router-view/>
              </transition>
            </b-col>    
      </b-row>
    </b-container>
  </div> -->

	<div>
		<transition name="fade-transform" mode="out-in">
			<router-view />
		</transition>
	</div>
</template>

<script>
// import Sidebar from "./Sidebar.vue"

export default {
	name: "NoSideBarMain",
};
</script>

<style scoped></style>
